import type { ComponentChildren } from 'preact';
import { h } from 'preact';
import * as styles from './popover.scss';
import type { Ref } from 'preact/hooks';
import { useEffect, useRef, useState } from 'preact/hooks';

const BUTTON_POPOVER_MARGIN = 4;

interface Props {
  anchorElementRef: Ref<HTMLButtonElement | null>;
  children: ComponentChildren;
}
export const Popover = ({ anchorElementRef, children }: Props): h.JSX.Element => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isPositioned, setIsPositioned] = useState(false);
  const popoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function calculatePosition(): void {
      if (!anchorElementRef.current) {
        return;
      }

      if (!popoverRef.current) {
        return;
      }

      const { height, top, left } = anchorElementRef.current.getClientRects()[0];
      const { width: popoverWidth } = popoverRef.current.getClientRects()[0];
      setPosition({
        x: left - popoverWidth,
        y: top + height + BUTTON_POPOVER_MARGIN
      });
      setIsPositioned(true);
    }

    calculatePosition();
  }, [anchorElementRef]);

  return (
    <div
      ref={popoverRef}
      className={styles.popoverContainer}
      style={{ left: `${position.x}px`, top: `${position.y}px`, opacity: isPositioned ? undefined! : 0 }}
    >
      {children}
    </div>
  );
};
